import Box from '@mui/material/Box'
import React from 'react'
import HalfSizeBanner from '../components/Banners/HalfSizeBanner'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import DoubleAccordion from '../components/Accordions/DoubleAccordion'
import TextBtnSection from '../components/Section/TextBtnSection'
import ContentCard from '../components/Cards/ContentCard'
import { useTranslation } from '../hook/Translation'
export default function JapaneseRestorativeHeadRitual() {
    const { t } = useTranslation();
 const accodirons = [
        {
            title: 'What it is?',
            content: 'This ritual begins with a calming foot soak infused with Himalayan salts and essential oils to ground you. Once on the massage table, you’ll experience a blend of massage techniques drawn from around the world: rhythmic Balinese-style strokes to ease muscle tension, gentle Hawaiian Lomi-Lomi waves for deep relaxation, and maybe some Thai stretching for energy flow. Warm aromatherapy oils a signature blend exclusive to RINU, perhaps with notes of frankincense, lavender, and citrus are used generously, cocooning your skin in moisture and your senses in a subtle fragrance. Hot stones may be placed on key points along your spine and chakra areas, their soothing heat penetrating deeply to melt away knots. Throughout,',
            content2: 'your therapist tunes the pressure to your preference, ensuring therapeutic relief (knots worked out from head, neck, shoulders) while never disrupting the meditative tranquility. The RINU Ritual often includes a brief scalp massage and foot reflexology segment, truly covering you from crown to toe. A soft chime or Tibetan singing bowl might gently ring at the conclusion, bringing you back to awareness.'
        },
        {
            title: 'How it works',
            content: 'Precise ablation at the surface plus controlled dermal heat stimulates collagen remodeling and new skin formation',
            content2: 'your therapist tunes the pressure to your preference, ensuring therapeutic relief (knots worked out from head, neck, shoulders) while never disrupting the meditative tranquility. The RINU Ritual often includes a brief scalp massage and foot reflexology segment, truly covering you from crown to toe. A soft chime or Tibetan singing bowl might gently ring at the conclusion, bringing you back to awareness.'
        },
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'text.secondary'}>
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: "Massage Therapies",
                        title: "Japanese Restorative Head Ritual (Scalp & Hair Therapy)",
                        description: "Youthful rejuvenation with minimal downtime. A gentle “soft-lift” laser therapy that uses a 1540 nm Erbium:Glass fractional laser to refresh skin tone and elasticity without significant peeling or recovery time.",
                        book: "",
                        learn: ""
                    }}
                />
            </Box>

            <Grid container gap={{md: '80px', xs: '50px'}} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '114px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <DoubleAccordion data={accodirons} />
                </Grid>
            </Grid>

            <Box bgcolor={'#DBDAD9'} paddingTop={{md: '120px', xs: ''}} paddingBottom={{md: '178px', xs: ''}} marginTop={{md: '125px', xs: ''}}>
                <Box className="generalContainer" marginX={'auto'} gap={'89px'} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            imageUrl: '/images/Mask_Group_7.png',
                            type: 'Pairing',
                            title: 'Massage Therapies',
                            description: 'This ritual is a fantastic add-on or finish to any of our services. After a facial, it’s the cherry on top you’re already reclined, we just extend the bliss to your scalp (plus, post-facial, people often don’t mind a hair treatment since they may be heading home to relax anyway). It also pairs with our Massage therapies',
                            direction: { md: 'row-reverse', xs: 'row' },
                            learn: "/skin/fractional-co2-resurfacing"
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: '/images/Mask_Group_7.png',
                            type: 'Pairing',
                            title: 'Led Light Scalp Treatment',
                            description: 'If you’re specifically looking to improve hair quality, we might pair the head ritual with recommendations for take-home Japanese haircare products, or even a LED light scalp treatment if hair thinning is a concern (we have certain low-level laser caps that can be used concurrently to stimulate follicles).',
                            learn: "/skin/hybrid-laser-erbium-glass",
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: '/images/Mask_Group_7.png',
                            type: 'Pairing',
                            title: 'Exomind',
                            description: 'Lastly, consider pairing with Exomind or a Meditation session a clear mind from meditation plus a relaxed scalp from the ritual equals mental heaven. Many guests tell us this becomes their favorite unwinding treat after a hectic week, as it clears mental clutter and feels utterly indulgent, yet it’s highly therapeutic.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            learn: "/skin/fractional-co2-resurfacing"
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: '/images/Mask_Group_7.png',
                            type: 'Pairing',
                            title: 'Meditation Session',
                            description: 'Lastly, consider pairing with Exomind or a Meditation session a clear mind from meditation plus a relaxed scalp from the ritual equals mental heaven. Many guests tell us this becomes their favorite unwinding treat after a hectic week, as it clears mental clutter and feels utterly indulgent, yet it’s highly therapeutic.',
                            learn: "/skin/hybrid-laser-erbium-glass",
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box>

        </Box>
    )
}